import React, { useState } from "react";
import {
	MdSchool,
	MdCake,
	MdCheckCircle,
	MdError,
	MdClose,
	MdFileDownload,
} from "react-icons/md";
import logo from "../assets/img/logo-kemenang.png";

const LulusDialog = (props) => {
	const data = props;
	const currentYear = new Date().getFullYear();

	return (
		<div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-md px-4">
			<div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl overflow-hidden animate-fade-in-up">
				{/* Modal Header */}
				<div
					className={`p-8 text-center ${data.lulus ? "bg-green-600" : "bg-red-600"} text-white`}
				>
					<div className="flex justify-center mb-4">
						{data.lulus ? (
							<MdCheckCircle className="text-6xl animate-bounce" />
						) : (
							<MdError className="text-6xl animate-pulse" />
						)}
					</div>
					<h2 className="text-2xl font-bold uppercase tracking-wider mb-1">
						{data.lulus
							? "SELAMAT! Anda dinyatakan LULUS"
							: "MOHON MAAF! Anda dinyatakan TIDAK LULUS"}
					</h2>
					<p className="text-white/80 text-sm">
						Pengumuman Kelulusan Siswa Madrasah DIY Tahun {currentYear}
					</p>
				</div>

				{/* Modal Body */}
				<div className="p-8 md:p-12">
					<div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
						<div className="space-y-4">
							<div>
								<label className="text-[10px] uppercase tracking-widest font-bold text-gray-400">
									NISN
								</label>
								<p className="font-bold text-gray-800">{data.nisn}</p>
							</div>
							<div>
								<label className="text-[10px] uppercase tracking-widest font-bold text-gray-400">
									Nama Lengkap
								</label>
								<p className="font-bold text-gray-800">{data.nama}</p>
							</div>
							<div>
								<label className="text-[10px] uppercase tracking-widest font-bold text-gray-400">
									TTL
								</label>
								<p className="font-bold text-gray-800">
									{data.tmp_lahir}, {data.tgl_lahir}
								</p>
							</div>
						</div>
						<div className="space-y-4">
							<div>
								<label className="text-[10px] uppercase tracking-widest font-bold text-gray-400">
									Jenis Kelamin
								</label>
								<p className="font-bold text-gray-800">{data.jk}</p>
							</div>
							<div>
								<label className="text-[10px] uppercase tracking-widest font-bold text-gray-400">
									Kelas
								</label>
								<p className="font-bold text-gray-800">{data.kelas}</p>
							</div>
							<div>
								<label className="text-[10px] uppercase tracking-widest font-bold text-gray-400">
									Asal Madrasah
								</label>
								<p className="font-bold text-gray-800">{data.jurusan}</p>
							</div>
						</div>
					</div>

					<div className="flex flex-col md:flex-row gap-4 items-center justify-center">
						{data.link && (
							<a
								href={data.link}
								target="_blank"
								rel="noopener noreferrer"
								className="flex items-center gap-2 bg-green-700 hover:bg-green-800 text-white font-bold px-8 py-4 rounded-lg shadow-lg transition-all duration-300"
							>
								<MdFileDownload className="text-xl" />
								Unduh SKL (PDF)
							</a>
						)}
						<button
							onClick={() => window.location.reload()}
							className="flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold px-8 py-4 rounded-lg transition-all duration-300"
						>
							<MdClose className="text-xl" />
							Tutup
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default function Home(props) {
	const [email, setEmail] = useState("");
	const [validationEmail, setValidationEmail] = useState(false);
	const [password, setPassword] = useState("");
	const [validationPassword, setValidationPassword] = useState(false);
	const [error, setError] = useState();
	const [skl, setSkl] = useState({});
	const [loading, setLoading] = useState(false);
	const currentYear = new Date().getFullYear();

	const doValidation = () => {
		setValidationEmail(false);
		setValidationPassword(false);

		if (!email || !password) {
			if (!email) setValidationEmail(true);
			if (!password) setValidationPassword(true);
			return;
		}
		doLogin();
	};

	const doLogin = () => {
		let data = { nisn: email, dt: password, s: "jmd" };
		setLoading(true);
		setError(null);

		fetch("/_api/skl/skl", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(data),
		})
			.then((res) => res.json())
			.then((result) => {
				if (result.error) {
					if (result.error.code === 40000) {
						window.alert("DATA KELULUSAN BELUM TERSEDIA");
					} else {
						setError(result.error.code);
					}
				} else {
					if (result.nisn) setSkl(result);
				}
			})
			.catch(() => setError(true))
			.finally(() => setLoading(false));
	};

	return (
		<div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-600 via-green-700 to-green-800 p-6">
			{/* Decorative Circles */}
			<div className="fixed top-[-10%] left-[-10%] w-[40%] h-[40%] bg-green-400/20 rounded-full blur-[100px] pointer-events-none" />
			<div className="fixed bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-green-900/40 rounded-full blur-[100px] pointer-events-none" />

			<div className="relative w-full max-w-[480px] bg-white rounded-2xl shadow-2xl overflow-hidden p-8 md:p-12 animate-fade-in-up">
				{/* Header */}
				<div className="text-center mb-10">
					<img
						className="mx-auto mb-6 w-32 drop-shadow-lg"
						src={logo}
						alt="Logo"
					/>
					<h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-3 leading-tight uppercase tracking-tight">
						PORTAL PENGUMUMAN KELULUSAN SISWA/I MADRASAH DIY
					</h1>
					<div className="flex items-center justify-center gap-2">
						<span className="h-px w-8 bg-green-200" />
						<p className="text-green-600 font-bold text-sm uppercase tracking-widest">
							Tahun {currentYear}
						</p>
						<span className="h-px w-8 bg-green-200" />
					</div>
				</div>

				{/* Form */}
				<form
					className="space-y-6"
					onSubmit={(e) => {
						e.preventDefault();
						doValidation();
					}}
				>
					<div className="space-y-1.5">
						<label className="text-sm font-bold text-gray-700 ml-1">
							NISN Siswa
						</label>
						<div
							className={`relative flex items-center transition-all duration-300 ${
								validationEmail || error === 40001
									? "ring-2 ring-red-500"
									: "ring-1 ring-gray-200 focus-within:ring-2 focus-within:ring-green-500"
							} rounded-lg bg-gray-50/50 p-1`}
						>
							<div className="pl-3 pr-2 text-gray-400">
								<MdSchool className="text-xl" />
							</div>
							<input
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								type="text"
								placeholder="Masukkan NISN"
								className="w-full bg-transparent px-2 py-3.5 text-sm text-gray-800 outline-none placeholder:text-gray-400 font-medium"
								required
							/>
						</div>
						{validationEmail && (
							<p className="text-xs text-red-500 flex items-center gap-1 mt-1 ml-1">
								<MdError className="inline-block" /> NISN tidak boleh kosong
							</p>
						)}
					</div>

					<div className="space-y-1.5">
						<label className="text-sm font-bold text-gray-700 ml-1">
							Tanggal Lahir
						</label>
						<div
							className={`relative flex items-center transition-all duration-300 ${
								validationPassword || error === 40001
									? "ring-2 ring-red-500"
									: "ring-1 ring-gray-200 focus-within:ring-2 focus-within:ring-green-500"
							} rounded-lg bg-gray-50/50 p-1`}
						>
							<div className="pl-3 pr-2 text-gray-400">
								<MdCake className="text-xl" />
							</div>
							<input
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								type="date"
								className="w-full bg-transparent px-2 py-3.5 text-sm text-gray-800 outline-none font-medium uppercase"
								required
							/>
						</div>
						{validationPassword && (
							<p className="text-xs text-red-500 flex items-center gap-1 mt-1 ml-1">
								<MdError className="inline-block" /> Tanggal Lahir tidak boleh
								kosong
							</p>
						)}
						{error === 40001 && (
							<p className="text-xs text-red-500 flex items-center gap-1 mt-1 ml-1 font-bold">
								<MdError /> NISN atau Tanggal Lahir tidak ditemukan
							</p>
						)}
					</div>

					<button
						type="submit"
						disabled={loading}
						className="w-full bg-green-600 hover:bg-green-700 disabled:bg-gray-300 text-white font-bold py-4 rounded-lg shadow-xl shadow-green-900/30 transition-all duration-300 transform hover:-translate-y-1 mt-4 text-base tracking-widest uppercase"
					>
						{loading ? (
							<div className="flex items-center justify-center gap-2">
								<div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
								<span>Memproses...</span>
							</div>
						) : (
							"Cek Kelulusan"
						)}
					</button>
				</form>

				<p className="text-center text-gray-400 text-[10px] mt-10 uppercase tracking-widest font-bold">
					&copy; Kanwil Kemenag DIY
				</p>
			</div>

			{skl.nisn && <LulusDialog {...skl} />}
		</div>
	);
}
